import type { FC, ReactNode } from 'react'

import ProductsProvider from 'components/ProductsProvider'

interface Props {
  children: ReactNode
}

const RootProviders: FC<Props> = ({ children }) => (
  <ProductsProvider>{children}</ProductsProvider>
)

export default RootProviders
